import _classCallCheck from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// @author Balazs Forian-Szabo
//
// ## Description
//
// A basic implementation of grace notes
// to be rendered on a tab stave.
//
// See `tests/gracetabnote_tests.js` for usage examples.
import { Vex } from './vex';
import { TabNote } from './tabnote';
export var GraceTabNote = /*#__PURE__*/function (_TabNote) {
  _inherits(GraceTabNote, _TabNote);

  _createClass(GraceTabNote, null, [{
    key: "CATEGORY",
    get: function get() {
      return 'gracetabnotes';
    }
  }]);

  function GraceTabNote(note_struct) {
    var _this;

    _classCallCheck(this, GraceTabNote);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GraceTabNote).call(this, note_struct, false));

    _this.setAttribute('type', 'GraceTabNote');

    Vex.Merge(_this.render_options, {
      // vertical shift from stave line
      y_shift: 0.3,
      // grace glyph scale
      scale: 0.6,
      // grace tablature font
      font: '7.5pt Arial'
    });

    _this.updateWidth();

    return _this;
  }

  _createClass(GraceTabNote, [{
    key: "getCategory",
    value: function getCategory() {
      return GraceTabNote.CATEGORY;
    }
  }, {
    key: "draw",
    value: function draw() {
      _get(_getPrototypeOf(GraceTabNote.prototype), "draw", this).call(this);

      this.setRendered();
    }
  }]);

  return GraceTabNote;
}(TabNote);